import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [trainer, setTrainer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('ptm_token');
    if (token) {
      api.get('/auth/me')
        .then((data) => setTrainer(data))
        .catch(() => localStorage.removeItem('ptm_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  async function login(email, password) {
    const data = await api.post('/auth/login', { email, password });
    localStorage.setItem('ptm_token', data.token);
    setTrainer(data.trainer);
    return data;
  }

  async function register(name, email, password, business_name, unit_system, website, health_data_consent = false) {
    const data = await api.post('/auth/register', { name, email, password, business_name, unit_system: unit_system || 'metric', website: website || '', health_data_consent });
    localStorage.setItem('ptm_token', data.token);
    setTrainer(data.trainer);
    return data;
  }

  async function loginWithToken(token, trainerData) {
    localStorage.setItem('ptm_token', token);
    setTrainer(trainerData);
  }

  async function refreshTrainer() {
    try {
      const data = await api.get('/auth/me');
      setTrainer(data);
    } catch (err) {
      // silent
    }
  }

  function logout() {
    localStorage.removeItem('ptm_token');
    setTrainer(null);
  }

  const isImperial = trainer?.unit_system === 'imperial';
  const isUK = trainer?.unit_system === 'metric';
  const isAdmin = trainer?.role === 'admin';

  return (
    <AuthContext.Provider value={{ trainer, loading, login, register, loginWithToken, refreshTrainer, logout, isImperial, isAdmin, isUK }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
